const openProfile = (memberId) => {
  return new Promise((resolve, reject) => {
    window.location = `/members/${memberId}`;
  });
}

export default openProfile;
